import { z } from 'zod';

/**
 * Body of `GET /api/system/version` (inside the usual `{ data }` envelope).
 *
 * - `version`    — the server's own build version, advertised as "the latest".
 * - `minVersion` — the oldest client build the server still accepts. A running
 *                  app whose bundled version is below this must hard-block and
 *                  force an update (see the VersionGate on each client).
 * - `updateUrl`  — where to send the user to get the new build, when set.
 */
export const SystemVersionSchema = z.object({
  version: z.string(),
  minVersion: z.string(),
  updateUrl: z.string().url().nullable().optional(),
});

export type SystemVersion = z.infer<typeof SystemVersionSchema>;
